export default __webpack_public_path__ + "static/media/shortcode.b5483cee.svg";